import type { Language } from '@/types';
import { wordOfDayApi } from '@/lib/api';
import { useOptimizedQuery } from './useOptimizedQuery';

export function useWordOfDay(language: Language) {
  return useOptimizedQuery({
    queryKey: ['word-of-day', language],
    queryFn: () => wordOfDayApi.getToday(language),
    tier: 'dynamic', // Changes daily, 1 hour staleTime is appropriate
  });
}
